import { apolloPlugin } from "./apollo";
import { caslPlugin } from "./casl";
import { launchdarklyPlugin } from "./launchdarkly";
import { homeAutomation } from "./homeAutomation";

export default [apolloPlugin, caslPlugin, launchdarklyPlugin, homeAutomation];
